import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from './Home.vue'
import Edit from './Edit.vue'
import Tag from './Tag.vue'

Vue.use(VueRouter)

const router = new VueRouter({
  base: process.env.PUBLIC_PATH,
  routes: [
    {
      path: '/',
      component: Home
    },
    {
      path: '/edit',
      component: Edit
    },
    {
      path: '/tag',
      component: Tag
    }
  ]
})

export default router
